var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "delivery-date" },
    [
      _c("div", { staticClass: "delivery-date__title" }, [
        _vm._v("\n    Дата и время\n  ")
      ]),
      _c("ui-select", {
        staticClass: "delivery-date__date",
        attrs: {
          label: "Дата *",
          placeholder: "Выберите дату доставки",
          options: _vm.dates,
          value: _vm.dateIdTemp,
          loading: _vm.UPDATE_PROGRESS
        },
        on: { change: _vm.handleDate }
      }),
      _c("ui-select", {
        ref: "time",
        staticClass: "delivery-date__time",
        attrs: {
          label: "Время *",
          placeholder: "Выберите время доставки",
          options: _vm.times,
          value: _vm.timeIdTemp,
          loading: _vm.UPDATE_PROGRESS
        },
        on: { change: _vm.handleTime }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }